var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseGreyBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 18.3337C14.6027 18.3337 18.3337 14.6027 18.3337 10.0003C18.3337 5.39795 14.6027 1.66699 10.0003 1.66699C5.39795 1.66699 1.66699 5.39795 1.66699 10.0003C1.66699 14.6027 5.39795 18.3337 10.0003 18.3337ZM8.65356 7.18042C8.24677 6.77363 7.58722 6.77363 7.18042 7.18042C6.77363 7.58722 6.77363 8.24677 7.18042 8.65356L8.52719 10.0003L7.18042 11.3471C6.77363 11.7539 6.77363 12.4134 7.18042 12.8202C7.58722 13.227 8.24677 13.227 8.65356 12.8202L10.0003 11.4735L11.3471 12.8202C11.7539 13.227 12.4134 13.227 12.8202 12.8202C13.227 12.4134 13.227 11.7539 12.8202 11.3471L11.4735 10.0003L12.8202 8.65356C13.227 8.24677 13.227 7.58722 12.8202 7.18042C12.4134 6.77363 11.7539 6.77363 11.3471 7.18042L10.0003 8.52719L8.65356 7.18042Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGreyBg);
export default __webpack_public_path__ + "static/media/close-grey-bg.35b19d4ceeb473334656cf324ba4cc79.svg";
export { ForwardRef as ReactComponent };